module.exports = __webpack_public_path__ + "media/audio36.9914d70f.mp3";